import { render } from "./ButtonCta.vue?vue&type=template&id=01c218a9&scoped=true"
import script from "./ButtonCta.vue?vue&type=script&lang=js"
export * from "./ButtonCta.vue?vue&type=script&lang=js"

import "./ButtonCta.vue?vue&type=style&index=0&id=01c218a9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01c218a9"]])

export default __exports__